module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-viewer",
    class: {
      loaderAnimationIn: _vm.show
    },
    attrs: {
      "id": "modal-loader"
    }
  }, [_c('div', {
    class: {
      'loader-bar-animated': !_vm.isStatic, 'loader-bar': _vm.isStatic
    }
  }, [_c('div', {
    staticClass: "bar",
    class: {
      error: _vm.isError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "loader-contents"
  }, [(_vm.hasDismiss) ? _c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (!_vm.title || _vm.title === '') ? _c('h2', {
    staticClass: "loader-title",
    class: {
      error: _vm.isError
    }
  }, [_vm._v(_vm._s(_vm.$t('heading.title')))]) : _vm._e(), _vm._v(" "), (_vm.title && _vm.title !== '') ? _c('h2', {
    staticClass: "loader-title",
    class: {
      error: _vm.isError
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('h2', {
    staticClass: "loader-title error"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("error_outline")])]) : _vm._e(), _vm._v(" "), (!_vm.message || _vm.message === '') ? _c('p', [_vm._v(_vm._s(_vm.$t('heading.message')))]) : _vm._e(), _vm._v(" "), (_vm.message && _vm.message !== '') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35c9c72a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/loader/loader.vue
// module id = 126
// module chunks = 0